{
  "fr": {
    "external_roles": {
      "MAITRE_D_OUVRAGE": "Maître d'ouvrage",
      "CHEF_D_ETABLISSEMENT": "Chef d'établissement",
      "MAITRE_D_OUVRAGE_-_CHEF_D’ETABLISSEMENT": "Maître d'ouvrage - Chef d'établissement",
      "MAITRE_D_OUVRAGE_DELEGUE": "Maître d'ouvrage délégué",
      "ASSISTANT_MAITRE_D_OUVRAGE": "Assistant Maître d'ouvrage",
      "ARCHITECTE_-_MAITRE_D_ŒUVRE": "Architecte - Maître d'œuvre",
      "Economiste": "Économiste",
      "Géotechnicien": "Géotechnicien",
      "BET_Structure": "BET structure",
      "BET_Electricité": "BET électricité",
      "BET_Energie_Fluide": "BET énergie fluide",
      "BET_Acoustique": "BET acoustique",
      "BET_Autre": "BET",
      "OPC": "OPC",
      "BIM_MANAGER": "BIM manager",
      "COORDINATEUR_SSI": "Coordinateur SSI",
      "COORDINATEUR_SPS": "Coordinateur SPS",
      "ENTREPRISE_": "Entreprise",
      "BET_EXECUTION": "BET exécution",
      "LABORATOIRE": "Laboratoire",
      "PREVENTIONNISTE_/_SDIS": "Préventionniste / SDIS",
      "COMMISSION_D_ACCESSIBILITE": "Commission d'accessibilité",
      "ENTREPRISE_GENERALE": "Entreprise Générale",
      "SERVICES_ADMINISTRATIFS": "Services administratifs"
    }
  },
  "en": {
    "external_roles": {
      "MAITRE_D_OUVRAGE": "Project Owner",
      "CHEF_D_ETABLISSEMENT": "Establishment Manager",
      "MAITRE_D_OUVRAGE_-_CHEF_D’ETABLISSEMENT": "Project Owner - Establishment Manager",
      "MAITRE_D_OUVRAGE_DELEGUE": "Delegated Project Owner",
      "ASSISTANT_MAITRE_D_OUVRAGE": "Project Owner Assistant",
      "ARCHITECTE_-_MAITRE_D_ŒUVRE": "Architect - Project Manager",
      "Economiste": "Economist",
      "Géotechnicien": "Geotechnician",
      "BET_Structure": "Structure Engineering Office",
      "BET_Electricité": "Electricity Engineering Office",
      "BET_Energie_Fluide": "Energy and Fluid Engineering Office",
      "BET_Acoustique": "Acoustics Engineering Office",
      "BET_Autre": "Engineering Office",
      "OPC": "OPC",
      "BIM_MANAGER": "BIM Manager",
      "COORDINATEUR_SSI": "SSI Coordinator",
      "COORDINATEUR_SPS": "SPS Coordinator",
      "ENTREPRISE_": "Company",
      "BET_EXECUTION": "Execution Engineering Office",
      "LABORATOIRE": "Laboratory",
      "PREVENTIONNISTE_/_SDIS": "Preventionist / Fire Service",
      "COMMISSION_D_ACCESSIBILITE": "Accessibility Commission",
      "ENTREPRISE_GENERALE": "General Contractor",
      "SERVICES_ADMINISTRATIFS": "Administrative Services"
    }
  },
  "nl": {
    "external_roles": {
      "MAITRE_D_OUVRAGE": "Bouwheer",
      "CHEF_D_ETABLISSEMENT": "Hoofd van de instelling",
      "MAITRE_D_OUVRAGE_-_CHEF_D’ETABLISSEMENT": "Opdrachtgever - Hoofd van de instelling",
      "MAITRE_D_OUVRAGE_DELEGUE": "Gedelegeerd afgevaardigde van de opdrachtgever",
      "ASSISTANT_MAITRE_D_OUVRAGE": "Assistent opdrachtgever",
      "ARCHITECTE_-_MAITRE_D_ŒUVRE": "architect",
      "Economiste": "Econoom",
      "Géotechnicien": "Geotechnicus",
      "BET_Structure": "Studiebureau stabiliteit",
      "BET_Electricité": "Studiebureau speciale technieken - elektriciteit",
      "BET_Energie_Fluide": "Studiebureau speciale technieken - sanitair",
      "BET_Acoustique": "Studiebureau akoestiek",
      "BET_Autre": "Studiebureau",
      "OPC": "Planning en coördinatie",
      "BIM_MANAGER": "BIM Manager",
      "COORDINATEUR_SSI": "Coördinator brandveiligheid",
      "COORDINATEUR_SPS": "Veiligheidscoördinator",
      "ENTREPRISE_": "Bedrijf",
      "BET_EXECUTION": "Studiebureau uitvoering",
      "LABORATOIRE": "Laboratorium",
      "PREVENTIONNISTE_/_SDIS": "Preventieadviseur",
      "COMMISSION_D_ACCESSIBILITE": "Toegankelijkheidscommissie",
      "ENTREPRISE_GENERALE": "Hoofdaannemer",
      "SERVICES_ADMINISTRATIFS": "Administratieve diensten"
    }
  }
}
